<template>
  <el-dialog :close-on-click-modal="false"  
    title="手续费设置"
    :visible.sync="visible"
    width="400px"
    class="serviceDialog"
    :before-close="handleClose"
    
  >
    <el-table :data="serviceData" class="servicee-table">
      <el-table-column prop="platNo" label="平台">
        <template slot-scope="scope">
          {{ dictMap['plat_no'][scope.row.platNo] }}
        </template>
      </el-table-column>
      <el-table-column prop="defaultRate" label="默认手续费" width="100">
        <template slot-scope="scope">
          {{ scope.row.defaultRate }}%
        </template>
      </el-table-column>
      <el-table-column prop="rate" label="手续汇率">
        <template slot-scope="scope">
          <el-input
            v-model="scope.row.rate"
            class="input"
            size="small"
            style="width: 90px;"
            type="number"
          ></el-input> % 
        </template>
      </el-table-column>
    </el-table>
    <div class="tip">
      <span class="store-info-icon">说明！</span>
      未填写手续费率的平台，系统将使用默认费率计算。
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose" size="small">返回</el-button>
      <el-button type="primary" @click="sure" size="small">
        确定
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { listPlatFee, addPlatFee } from '@/api/order/all'
import { mapGetters } from "vuex"

export default {
  name: "ServiceDialog",
  data() {
    return {
      serviceData: [],
    };
  },
  props: {
    visible: {
      type: Boolean,
      default() {
        return false;
      },
    },
  },
  computed: {
    ...mapGetters(["dictData", "dictMap"]),
  },
  watch: {
    visible() {
      this.getData();
    }
  },
  methods: {
    getData() {
      listPlatFee().then(res => {
        this.serviceData = res.data
      })
    },
    sure() {
      addPlatFee(this.serviceData).then(res => {
        if (res.code !== 200) {
          this.$message.error("修改失败")
        } else {
          this.$message.success("修改成功")
          this.$emit("onOk");
        }
      })
    },
    handleClose() {
      this.$emit("onClose");
    },
  },
};
</script>

<style scoped>
.serviceDialog {
  font-size: 12px;
}
.tip {
  margin-top: 10px;
  font-size: 12px;
}
.tip .store-info-icon {
  display: inline-block;
  padding: 0 0 0 5px;
  background: #129ba7;
  color: #fff;
  border-radius: 2px;
  margin-right: 5px;
  line-height: 1.4;
}
</style>
